"use client";
import {Button} from "@/components/ui/button";
import Link from "next/link";
import AuthAction from "@/components/site/AuthAction";
import {signOut, useSession} from "next-auth/react";




export default  function Hero({isActivity = false}){

    return(
        <section className={"h-[80vh] mb-10"}>
            <div className={"absolute h-[80vh]  w-full"}>
                <img src={"/hero.jpg"} alt={"Hero"} className={"max-h-full w-full object-cover hero-position"}/>
            </div>

            <div className={"relative bg-opacity-70 bg-black h-full w-full flex flex-col justify-center items-center gap-y-4"}>
                <div className={"text-center"}>
                    {/*<h1 className={"text-3xl md:text-4xl text-white"}></h1>*/}
                    <h1 className={"text-3xl md:text-4xl text-primary"}><span className={"text-white"}>CWF-Coworkfit</span> votre partenaire</h1>
                    <h1 className={"text-3xl md:text-4xl text-primary"}>Sport santé et bien être</h1>
                </div>
                <div className={"flex flex-col md:flex-row  gap-4"}>
                    <Button className={"text-white"} asChild>
                        <Link href={"/events"}>
                            {isActivity ? "Découvrez les activités" :"Découvrez l'open training"}
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    )
}
